/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Checkbox, FormLabel, Grid } from '@material-ui/core';

/**
 * region for styles*/
import { checkListKeywordStyle } from './style/checkListKeywordStyle';

class CheckListKeyword extends Component {

    handleDrawerDetailsOpen(keyword, event) {
        let self = this;
        if (keyword != null) {
            self.props.handleDrawerDetailsOpen(keyword);
        }
    }

    handleChangeCheckbox(keyword) {
        this.props.handleChangeCheckbox(keyword);
    }

    render() {

        const { classes } = this.props;

        return (
            <Grid item xs={12}>
                <Grid container item xs={12} spacing={0}>
                    {this.props.keywordsFound.map((keyword, index) =>
                        <Grid item xs={4} key={index}>
                            <div className={classes.contentCheckbox}>
                                <Checkbox
                                    checked={keyword.CHECKED}
                                    onChange={this.handleChangeCheckbox.bind(this, keyword)}
                                    color="default"
                                    value={keyword.IDKEYWORD} />
                                <FormLabel
                                    component="label"
                                    onClick={this.handleDrawerDetailsOpen.bind(this, keyword)}
                                    className={keyword.WITHOUTCATEGORY ? classes.labelCheckboxColorRed : classes.labelCheckboxBlack} >
                                        {keyword.MATCHWITHCATEGORY ? <b>{keyword.KEYWORD}</b> : keyword.KEYWORD}
                                </FormLabel>
                            </div>
                        </Grid>)
                    }
                </Grid>
            </Grid>
        );
    }
}
CheckListKeyword.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(checkListKeywordStyle)(CheckListKeyword);